"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/material/styles");

var _wrapper = require("@uniqore/wrapper");

var _Icons = _interopRequireDefault(require("../Common/Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const UqSelectButton = (0, _styles.styled)(_wrapper.UqButton)(() => ({
  borderRadius: '4px',
  boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
  '&:hover': {
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)'
  }
}));

const SelectButtonGroup = ({
  selectButtons = [],
  values = [],
  onChange,
  buttonsColor = 'primary',
  marginHorizontal,
  marginVertical = 4,
  marginTop,
  marginBottom,
  className,
  style
}) => {
  const [selectedValues, setSelectedValues] = _react.default.useState(values);

  const handleClick = value => () => {
    const index = selectedValues.indexOf(value);
    const newSelectedValues = [...selectedValues];

    if (index === -1) {
      newSelectedValues.push(value);
    } else {
      newSelectedValues.splice(index, 1);
    }

    setSelectedValues(newSelectedValues);

    if (onChange) {
      onChange(newSelectedValues);
    }
  };

  return _react.default.createElement(_wrapper.UqBox, {
    marginVertical: marginVertical,
    marginHorizontal: marginHorizontal,
    marginTop: marginTop,
    marginBottom: marginBottom,
    style: style,
    className: className
  }, selectButtons.map((selectButton, i) => _react.default.createElement(UqSelectButton, {
    key: i,
    value: selectButton.value,
    onClick: handleClick(selectButton.value),
    color: selectButton.color === 'inherit' ? buttonsColor : selectButton.color || buttonsColor,
    variant: selectedValues.indexOf(selectButton.value) !== -1 ? 'contained' : 'text',
    startIcon: selectButton.startIcon ? _react.default.createElement(_Icons.default[selectButton.startIcon]) : null,
    size: "large",
    disableFocusRipple: true,
    disableRipple: true,
    disableTouchRipple: true,
    marginVertical: 4,
    fullWidth: true,
    sx: {
      height: '42px',
      paddingLeft: '16px',
      paddingRight: '16px'
    }
  }, !selectButton.metaText ? selectButton.text : _react.default.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, _react.default.createElement(_wrapper.UqTypography, {
    variant: "button",
    component: "span"
  }, selectButton.text), _react.default.createElement(_wrapper.UqTypography, {
    variant: "caption",
    component: "span",
    sx: {
      alignSelf: 'center'
    }
  }, selectButton.metaText)))));
};

var _default = SelectButtonGroup;
exports.default = _default;